import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import React from 'react';
import { useIdPrefix } from '@jbhi-fi/components/src/IdPrefix';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { formatStockLevelStatus } from '../utils/utils';
import { styles } from './LogoBannerTag.css';
import BannerTag from '@jbhi-fi/lanyard-ui/components/BannerTag';
import { LimitedRunPromoTag } from '@jbhi-fi/components/src/ProductTags/LimitedRunPromoTag';
import { PromoTag as PromoTagType } from '@jbhi-fi/components/src/ProductCard/utils/getTags';
import { PromoTags } from '../promoTags/PromoTags';
import { LimitedRunPromo } from '@jbhi-fi/apis/src/shopify/types/OnlineProduct';

export type LogoBannerTagProps = {
  logo?: string;
  brand?: string;
  productDepartment?: number;
  pdpDepartmentTitleIds?: Array<string>;
  softwareFormat?: string;
  className?: string;
  limitedRunPromo?: LimitedRunPromo;
  isComingSoon?: boolean;
  isPerksMember?: boolean;
  bannerLabel?: string;
  promoTags?: Array<PromoTagType> | null;
};

export const LogoBannerTag = ({
  logo,
  brand,
  productDepartment,
  pdpDepartmentTitleIds,
  softwareFormat,
  className,
  limitedRunPromo,
  isComingSoon,
  bannerLabel,
  promoTags,
}: LogoBannerTagProps): JSX.Element => {
  const isDesktop = useBreakpoint('lg', 'up');
  const hasBannerLabel = !!bannerLabel;
  const isActiveLimitedRun = (limitedRunPromo?.IsActive && !isComingSoon) ?? false;
  const hasSoftwareFormat =
    !logo && softwareFormat && pdpDepartmentTitleIds?.some(item => item.trim() === productDepartment?.toString());

  const elementIds = {
    brandLogoWrapper: useIdPrefix('brand-logo-wrapper'),
    brandLogo: useIdPrefix('brand-logo'),
    bannerLabel: useIdPrefix('banner-label'),
  };

  return (
    <>
      {hasBannerLabel || isActiveLimitedRun ? (
        <div className={classNames([styles.BannerTagContainer, className])} id={elementIds.bannerLabel}>
          {isActiveLimitedRun && limitedRunPromo?.StockLevelStatus ? (
            <div className={styles.banner}>
              <LimitedRunPromoTag label={formatStockLevelStatus(limitedRunPromo?.StockLevelStatus)} />
            </div>
          ) : null}
          {hasBannerLabel ? <BannerTag size="lg" label={bannerLabel} testId="pdp-banner-tag"/> : null}
        </div>
      ) : null}

      {promoTags && promoTags.length > 0 && !isDesktop ? <PromoTags promoTags={promoTags} /> : null}

      {logo || hasSoftwareFormat ? (
        <div className={styles.brandLogoContainer} id={elementIds.brandLogoWrapper}>
          {logo ? <img className={styles.brandLogo} src={logo} alt={brand} id={elementIds.brandLogo} /> : null}
          {hasSoftwareFormat ? <span className={styles.softwareFormatTitle}>{softwareFormat}</span> : null}
        </div>
      ) : null}
    </>
  );
};

export default LogoBannerTag;
